// extracted by mini-css-extract-plugin
export default {"deviceName":"HeaderDeviceDetails_deviceName__p19HN","deviceInfos":"HeaderDeviceDetails_deviceInfos__T6RIw","tags":"HeaderDeviceDetails_tags__FmJV2"};